export enum UserRoles {
    USER = 0,
    ADMIN_BASIC = 1,
    ADMIN_OPERATIONS = 2,
    ADMIN_OPERATIONS_SUPPORT = 3,
    ADMIN_PRODUCERS = 4,
    ADMIN_FINANCE = 5,
    ADMIN_FINANCE_SUPPORT = 6,
    ADMIN_CONTRACTS = 7,
    ADMIN_MASTER = 8,
    ADMIN_DEVELOPER = 9,
    CONSULTANT = 10,
}

export type PermissionRoles = UserRoles | UserRoles[]
